import { japanese, cantonese, korean } from './locale/index'

const toString = Object.prototype.toString

export default class Translator {
  _map = {}

  constructor(language = [], options) {
    if (toString.call(language) !== '[object Array]') {
      throw TypeError('parameter language must be an Array!')
    }
    this.language = language
    this.options = options || {}
    this._init()
  }

  _init() {
    for (const pair of this.language) {
      const [key, value] = pair.split(' ')
      this._map[key] = value
    }

    const cover = this.options.cover
    if (cover && toString.call(cover) !== '[object Object]') {
      for (const key in cover) {
        this._map[key] = cover[key]
      }
    }
  }

  /**
   *
   * @param {String} text
   * @param {String} [placeholder] 如果找不到匹配的值，用此值翻译，不传则默认是使用原值
   */
  translate(text, placeholder) {
    let result = ''
    const _map = this._map
    const wordList = text.split('')

    for (const word of wordList) {
      if (_map[word]) {
        result += `${_map[word]} `
        continue
      }

      result += placeholder || word
    }

    return result
  }
}

export const japaneseTls = new Translator(japanese)
export const cantoneseTls = new Translator(cantonese)
export const koreanTls = new Translator(korean)
